import React, { useContext } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import { AuthProvider, AuthContext } from './context/AuthContext';
import LoginForm from './components/LoginForm';
import Dashboard from './pages/Dashboard';
import Pacientes from './pages/Pacientes';
import Calendario from './pages/Calendario';
import Facturacion from './pages/Facturacion';
import HistorialPaciente from './pages/HistorialPaciente';
import HistorialClinico from './pages/HistorialClinico';
import HistorialEconomico from './pages/HistorialEconomico';
import Presupuesto from './pages/Presupuesto';
import FacturacionGeneral from './pages/FacturacionGeneral';
import Odontograma from './pages/Odontograma';
import ImagenesPaciente from './pages/ImagenesPaciente';
import Auditoria from './pages/Auditoria';

function PrivateRoute({ children, ...rest }) {
  const { token } = useContext(AuthContext);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        token ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}

function RoleRoute({ allowedRoles, children, ...rest }) {
  const { roles } = useContext(AuthContext);
  const hasAccess = roles.some(r => allowedRoles.includes(r));

  return (
    <Route
      {...rest}
      render={() =>
        hasAccess ? children : <Redirect to="/dashboard" />
      }
    />
  );
}


export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Switch>
          <Route path="/login" component={LoginForm} />
          <PrivateRoute path="/dashboard">
            <Dashboard />
          </PrivateRoute>
          <PrivateRoute exact path="/pacientes">
            <Pacientes />
          </PrivateRoute>
          <PrivateRoute exact path="/pacientes/nuevo">
            <HistorialPaciente isNew />
          </PrivateRoute>
          <PrivateRoute exact path="/pacientes/:expediente/historial-clinico/odontograma">
            <Odontograma />
          </PrivateRoute>
          <PrivateRoute path="/pacientes/:expediente/historial-economico">
            <HistorialEconomico />
          </PrivateRoute>
          <PrivateRoute path="/pacientes/:expediente/historial-clinico">
            <HistorialClinico />
          </PrivateRoute>
          <PrivateRoute path="/pacientes/:expediente/imagenes">
            <ImagenesPaciente />
          </PrivateRoute>
          <PrivateRoute exact path="/pacientes/:expediente">
            <HistorialPaciente />
          </PrivateRoute>
          <PrivateRoute path="/presupuesto">
            <Presupuesto />
          </PrivateRoute>
          <PrivateRoute exact path="/pacientes/:expediente/odontograma">
            <Odontograma />
          </PrivateRoute>
          <PrivateRoute path="/calendario">
            <Calendario />
          </PrivateRoute>
          <RoleRoute path="/facturacion/general" allowedRoles={['ADMIN', 'ODONTOLOGO']}>
            <FacturacionGeneral />
          </RoleRoute>
          <RoleRoute path="/facturacion" allowedRoles={['ADMIN', 'ODONTOLOGO']}>
            <Facturacion />
          </RoleRoute>
          <RoleRoute path="/auditoria" allowedRoles={['ADMIN', 'ODONTOLOGO']}>
            <Auditoria />
          </RoleRoute>
          <Redirect from="*" to="/login" />
        </Switch>
      </BrowserRouter>
    </AuthProvider>
  );
}
